import { render, staticRenderFns } from "./WbbookFriend.vue?vue&type=template&id=76eec44f&scoped=true&"
import script from "./WbbookFriend.vue?vue&type=script&lang=js&"
export * from "./WbbookFriend.vue?vue&type=script&lang=js&"
import style0 from "./WbbookFriend.vue?vue&type=style&index=0&id=76eec44f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eec44f",
  null
  
)

export default component.exports